<template>
<div class="chapter">
<div class="inner_page">
<p><span class="calibre3"><br class="calibre4" id="calibre_pb_0"/></span></p>
<div class="Section1">
<br/>
<br/>
<p class="MsoNormal2"><span class="calibre1">Copyright © 1987 by Robyn Carr</span></p><br/>
<p class="MsoNormal2"><span class="calibre1">All rights reserved. No part of this book may be reproduced in any form or by any means without the prior written consent of the Publisher, excepting brief quotes used in reviews.</span></p><br/>
<p class="MsoNormal2"><span class="calibre1">Cover design by Natanya Wheeler</span></p><br/>
<p class="MsoNormal2"><span class="calibre1">For more information, please visit http://www.RobynCarr.com</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tempted02.vue?cc660cfa